
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"#363636","stroke-width":"0px"},attrs:{"d":"m47.19,0h-30.36C7.54,0,0,6.2,0,13.84v35.64c0,8.02,7.9,14.52,17.66,14.52h29.53c9.29,0,16.83-6.18,16.81-13.82V13.82c0-7.64-7.52-13.82-16.81-13.82Zm13.81,50.18c0,3.06-1.58,5.3-2.92,6.64-2.65,2.66-6.62,4.18-10.89,4.18h-29.53c-8.08,0-14.66-5.17-14.66-11.52V13.84c0-5.98,6.2-10.84,13.83-10.84h30.36c7.61,0,13.81,4.85,13.81,10.82v36.36Zm-29.62-2.91l-1.41-.08v-3.49c-8.55-.82-13.61-5.55-13.61-12.86.2-6.34,4.46-13.76,15.79-13.96,5.81-.11,9.56,2.32,11.65,4.38,2.67,2.62,4.19,6.12,4.19,9.59,0,4.54-1.56,8.32-4.65,11.23-4.98,4.7-11.86,5.21-11.97,5.21v-.02Zm.83-27.4c-9.22.17-12.68,5.8-12.85,11.01,0,8.17,7.63,9.72,12.17,9.92l1.44.06v3.15c3.58-.77,12.03-3.6,12.03-13.18,0-2.63-1.23-5.42-3.29-7.45-1.68-1.65-4.68-3.64-9.5-3.52h0Zm-8.14,11.06c-1.53,0-2.77-1.24-2.77-2.77s1.24-2.77,2.77-2.77,2.77,1.24,2.77,2.77-1.24,2.77-2.77,2.77Zm4.13-5.12c-1.01-1.15-.9-2.9.25-3.91,1.15-1.01,2.9-.9,3.91.25,1.01,1.15.9,2.9-.25,3.91-1.15,1.01-2.9.9-3.91-.25Zm7.08-.13c-.06-1.53,1.13-2.82,2.66-2.88,1.53-.06,2.82,1.13,2.88,2.66.06,1.53-1.13,2.82-2.66,2.88s-2.82-1.13-2.88-2.66Zm2.91,5.85c.99-1.17,2.74-1.32,3.91-.34,1.17.98,1.32,2.74.34,3.91-.98,1.17-2.74,1.32-3.91.34-1.17-.98-1.32-2.74-.34-3.91Z"}})])
          )
        }
      }
    